import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';

const MenuItemUI = (props) => (
  <MenuItem {...props}>
    { props.children }
  </MenuItem>
);

export default MenuItemUI;